import React from 'react';
import { useSelector } from 'react-redux';
import './start-page-hero-banner.scss';

export const StartPageHeroBanner = () => {
    const { bannerLinks } = useSelector(
        state => state.views.startPage.config.header
    );

    const content = (icon, text) => (
        <>
            {icon && icon.baseUrl && (
                <img
                    src={icon.baseUrl}
                    alt={text}
                    className="icon icon-md text-branded mr-1"
                />
            )}
            <span className="text-white text-styled">{text}</span>
        </>
    );

    return bannerLinks && bannerLinks.length > 0 ? (
        <div className="start-page-hero-banner bg-primary w-100 p-2 d-none d-md-flex justify-content-center">
            <div className="site-width d-flex w-100 align-items-center justify-content-between">
                {bannerLinks.map(({ text, url, icon }) => (
                    <div
                        className="start-page-hero-banner-item d-flex flex-grow-1 justify-content-center align-items-center"
                        key={text}>
                        {url ? (
                            <a href={url} target="_blank" rel="noreferrer">
                                {content(icon, text)}
                            </a>
                        ) : (
                            content(icon, text)
                        )}
                    </div>
                ))}
            </div>
        </div>
    ) : null;
};
